import { render, staticRenderFns } from "./Corridor_a_1_1.vue?vue&type=template&id=2b984a98&scoped=true&"
import script from "./Corridor_a_1_1.vue?vue&type=script&lang=js&"
export * from "./Corridor_a_1_1.vue?vue&type=script&lang=js&"
import style0 from "./Corridor_a_1_1.vue?vue&type=style&index=0&id=2b984a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b984a98",
  null
  
)

export default component.exports